<template>
	<div>
		<div class="hidden-xs hidden-sm head_11">
			<div class="top_top">
				<div class="wh"><span style="float: right;"><a href="#">中文 </a> | <a
							href="#">English</a></span>欢迎访问恒润集团官方网站</div>
			</div>
			<div class="wh flex_a">
				<div class="logo_11">
					<a href="javascript:void(0)" @click="go('/')"><img alt="" src="../../html/images/logo.png" /></a>
				</div>

				<div class="nnav">
					<ul class="x-menu clearfix">
						<li>
							<a href="javascript:void(0)" @click="go('/')">首页</a>
						</li>
						<li v-for="item in configList">
							<a href="javascript:void(0)">{{item.categoryName}}</a>
							<ul class="x-sub-menu" v-if="item.children.length>0">
								<li><a href="javascript:void(0)"
										v-for="items in item.children" @click="goTwo(items)">{{items.categoryName}}</a></li>
								<!-- <li><a href="02关于恒润 02 企业文化.html">企业文化</a></li>
								<li><a href="02关于恒润 03 发展历程.html">发展历程</a></li>
								<li><a href="02关于恒润 04 资质荣誉.html">资质荣誉</a></li> -->
							</ul>
						</li>
						<!-- <li>
							<a href="03集团动态 01 新闻列表.html">集团动态</a>
							<ul class="x-sub-menu">
								<li><a href="03集团动态 01 新闻列表.html">政策解读</a></li>
								<li><a href="03集团动态 01 新闻列表.html">新闻中心</a></li>
							</ul>
						</li>
						<li>
							<a href="04业务范围 01业务列表.html">业务范围</a>
							<ul class="x-sub-menu">
								<li><a href="04业务范围 01业务列表.html">水利市政</a></li>
								<li><a href="04业务范围 01业务列表.html">雷达天线</a></li>
								<li><a href="04业务范围 01业务列表.html">新能源</a></li>
								<li><a href="04业务范围 01业务列表.html">共享智造</a></li>
							</ul>
						</li>
						<li>
							<a href="06项目案例 01案例列表.html">项目案例</a>
							<ul class="x-sub-menu">
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="006项目案例 01案例列表.html">案例分类</a></li>
							</ul>
						</li>
						<li>
							<a href="07社会责任 01党建引领.html">社会责任</a>
							<ul class="x-sub-menu">
								<li><a href="07社会责任 01党建引领.html">党建引领</a></li>
								<li><a href="07社会责任 02责任担当.html">责任担当</a></li>
							</ul>
						</li>
						<li>
							<a href="08联系我们 02联系我们.html">联系我们</a>
							<ul class="x-sub-menu">
								<li><a href="08联系我们 01人才招聘.html">人才招聘</a></li>
								<li><a href="08联系我们 02联系我们.html">联系我们</a></li>
							</ul>
						</li> -->
					</ul>
				</div>
				<div class="head_33 flex_a">
					<div class="dh" style="font-size: 24px; font-weight: bold; text-align: right;">
						<img src="../../html/images/tel.png" alt="" width="35px"
							style="margin-right: 20px;">400-636-1169
					</div>
				</div>
			</div>
		</div>

		<!--pc_top-->
		<!--shoujitop-->
		<div class="xymob-head visible-sm visible-xs">
			<div class="xymob-head-box">
				<div class="xymob-logo">
					<div><a href="index.html"><img src="../../html/images/logo.png" /></a></div>
				</div>
				<div class="xymob-navbtn">
					<span></span>
				</div>

			</div>
			<div class="xymob-menu">
				<div class="xymob-menu-box">
					<ul class="xymob-nav">
						<li>
							<a href="javascript:void(0)" @click="go('/')">首页</a>
						</li>

						<li v-for="item in configList">
							<a href="javascript:void(0)">{{item.categoryName}}</a>

							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu" v-if="item.children.length>0">
								<li v-for="items in item.children"><a
										href="javascript:void(0)" @click="goTwo(items)">{{items.categoryName}}</a></li>
								<!-- <li><a href="02关于恒润 02 企业文化.html">企业文化</a></li>
								<li><a href="02关于恒润 03 发展历程.html">发展历程</a></li>
								<li><a href="02关于恒润 04 资质荣誉.html">资质荣誉</a></li> -->
							</ul>
						</li>
						<!-- <li>
							<a href="javascript:void(0)">集团动态</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="03集团动态 01 新闻列表.html">政策解读</a></li>
								<li><a href="03集团动态 01 新闻列表.html">新闻中心</a></li>
							</ul>
						</li>
						<li>
							<a href="javascript:void(0)">业务范围</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="04业务范围 01业务列表.html">水利市政</a></li>
								<li><a href="04业务范围 01业务列表.html">雷达天线</a></li>
								<li><a href="04业务范围 01业务列表.html">新能源</a></li>
								<li><a href="04业务范围 01业务列表.html">共享智造</a></li>
							</ul>
						</li>
						<li>
							<a href="javascript:void(0)">项目案例</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="06项目案例 01案例列表.html">案例分类</a></li>
								<li><a href="006项目案例 01案例列表.html">案例分类</a></li>
							</ul>
						</li>
						<li>
							<a href="javascript:void(0)">社会责任</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="07社会责任 01党建引领.html">党建引领</a></li>
								<li><a href="07社会责任 02责任担当.html">责任担当</a></li>
							</ul>
						</li>
						<li>
							<a href="javascript:void(0)">联系我们</a>
		
							<div class="xymob-menu-jt"><i class="icon-font icon-down"></i></div>
							<ul class="xymob-sub-menu">
								<li><a href="08联系我们 01人才招聘.html">人才招聘</a></li>
								<li><a href="08联系我们 02联系我们.html">联系我们</a></li>
							</ul>
						</li> -->

					</ul>

				</div>
			</div>

			<div class="xymob-search">
				<div class="xymob-search-close-btn"><i class="icon-font icon-close"></i></div>
				<div class="xymob-search-box">
					<form method="get" name="formsearch" id="formsearch" action="/search.php">
						<input type="text" name="wd" id="keyword" placeholder="请输入关键词" />
						<button type="submit" id="s_btn"><i class="icon-font"></i></button>
					</form>
				</div>
				<div class="xymob-seaerch-wz">
					<span>搜索</span>
					<a href=""></a>
				</div>
			</div>
		</div>
		<!--shoujitop-->

	</div>
</template>

<script>
	import {
		categorysortPage,
		articleList
	} from '@/api/reqFetch.js'
	import {
		clickToggle,
		backTop,
		placeholderSupport,
		iePlaceholder,
		antiClone
	} from '../../html/js/app_v.js'
	// import '../../html/js/main.js'
	export default {
		components: {},
		props: {

			sel: {
				type: String | Number,
				default: 1
			}

		},
		data() {
			return {
				showPhone: false,
				token: '',
				configList: [],
				title: '',
				selId: '',
				config: {
					homeUrl: '/',
					copyCode: "0",
					userName: ""
				}
			}
		},
		computed: {

		},
		mounted() {
			this.getCategorysortPage()
			var that=this
			// 手机端 到导航点击特效
			$(".xymob-menu-jt").click(function() {
				var xymobSubmenuBox = $(this).siblings('.xymob-sub-menu');
				var xymobSubmenuSiblingsBox = $(this).parents('li').siblings('li').find('.xymob-sub-menu');
				var xymobSubmenuSiblingsJt = $(this).parents('li').siblings('li').find('.xymob-menu-jt');
				if (!xymobSubmenuBox.is(":visible")) {
					$(this).addClass('clicked');
					xymobSubmenuBox.slideDown();
					xymobSubmenuSiblingsJt.removeClass('clicked');
					xymobSubmenuSiblingsBox.slideUp();
				} else {
					$(this).removeClass('clicked');
					xymobSubmenuBox.slideUp();
				}
			});

			// 获取本地文件夹名
			// 格式 /xypt/
			var localFileName = that.config.homeUrl.replace(window.location.origin, '');
			$(".x-menu a").each(function() {
				var AHref = $(this).attr('href');

				// 如果连接中不含有域名
				if (AHref.indexOf(that.config.homeUrl) === -1) {
					// 如果当前链接的第一个字符不是 '/'
					if (AHref.charCodeAt(0) !== 47) {
						AHref = '/' + AHref;
					}
					// 如果连接中不含有本地文件夹
					if (AHref.indexOf(localFileName) === -1) {
						// 路径就等于 配置相中的主域名+后台录入的地址
						AHref = that.config.homeUrl.substr(0, that.config.homeUrl.length - 1) + AHref;
					} else {
						// 否则 路径就等于 当前浏览器的origin+后台录入的地址
						AHref = window.location.origin + AHref;
					}
				}

				// 这个是路径一致的情况
				if (AHref === window.location.href) {
					$(".x-menu li").removeClass('active');
					// indexOf('x-sub-menu') 这里的 x-sub-menu 是下拉的元素类名，如果模板里改了类名这里也是要改的
					if ($(this).parent().parent().attr('class').indexOf('x-sub-menu') !== -1) {
						$(this).parent().parents('li').addClass('active')
					} else {
						$(this).parent().addClass('active')
					}
				}
			});



			//手机导航按钮点击效果
			clickToggle('.xymob-navbtn', '.xymob-menu');

			// // 手机搜索按钮点击
			// $(".xymob-search-btn").add('.xymob-search-close-btn').click(function () {
			//     $(".xymob-search").toggleClass('clicked');
			// });

			//导航条固定在头部
			if ($(window).scrollTop() > 30) {
				$('.xy-head').addClass('scroll');
			}
			$(window).scroll(function() {
				var len = $(this).scrollTop();
				if (len > 30) {
					$('.xy-head').addClass('scroll');
				} else {
					$('.xy-head').removeClass('scroll')
				}
			});

			//返回顶部
			backTop(".xymob-page-backtop", 300);

			// 搜索框判断
			$("input[name='wd']").each(function() {
				var _plac = $(this).attr('placeholder');
				$(this).focus(function() {
					$(this).attr('placeholder', '');
				});
				$(this).blur(function() {
					$(this).attr('placeholder', _plac);
				});
			});

			/* 内页共用js代码 */

			// 内页左侧导航栏点击特效
			$(".first-nav-btn").click(function() {
				var boxa = $(this).siblings('.xypg-left-subnav');
				var parbox = $(this).parents('li');
				var parSibBox = $(this).parents('li').siblings('li');
				var boxb = $(this).parents('li').siblings('li').find('.xypg-left-subnav');
				var jta = $(this).parents('li').siblings('li').find('.first-nav-btn');

				var subLiLen = boxa.find('li').length;
				if (subLiLen == 0) {
					return false
				}
				if (!boxa.is(":visible")) {
					boxa.slideDown();
					parbox.addClass('clicked');
					$(this).addClass('clicked');
					boxb.slideUp();
					jta.removeClass('clicked');
					parSibBox.removeClass('clicked');
				} else {
					boxa.slideUp();
					$(this).removeClass('clicked');
					parbox.removeClass('clicked');
				}
			});

			// 内页标题 字母获取
			$(".xypg-left-title").each(function() {
				var words = $(this).find('span').text();
				var firstLetter = words.substr(0, 1);
				$('<i>' + firstLetter + '</i>').appendTo($(this));
			});

			// 内页手机端端 做的导航弹出特效
			$(".xymob-page-navbtn").click(function() {
				$(".xymob-menu-click").addClass('click');
				$('html,body').addClass('no-scroll');
			});
			$(".xymob-left-close-btn").click(function() {
				$(".xymob-menu-click").removeClass('click');
				$('html,body').removeClass('no-scroll');
			});

			// 详情页面 相关产品滚动特效
			if ($(".relate-product-slick").length != 0) {
				$(".relate-product-slick").owlCarousel({
					margin: 14,
					dots: false,
					autoplay: true,
					responsive: {
						0: {
							items: 2
						},
						600: {
							items: 3
						},
						1000: {
							items: 4
						}
					}
				});
			}


			// 详情页下载文件 下拉点击特效
			clickToggle('.file-down-title', '.file-down-list');

			// 内页左侧当前分类颜色高亮
			$(".xypg-left-nav li a[href='" + window.location.href + "']").closest('li').addClass('clicked');
			$(".xypg-left-threenav .clicked").parents('.xypg-left-subnav').show();
			$(".xypg-left-threenav .clicked").parents('.xypg-left-threenav').show();
			$(".xypg-left-subnav .clicked").parents('.xypg-left-subnav').show();

			// ie9 兼容 placeholder
			if (!placeholderSupport()) {
				iePlaceholder()
			}

			// 防复制代码
			if (that.config.copyCode == 1 && !(navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i))) {
				antiClone();
			}


		},
		methods: {
			clickToggle(elea, eleb) {
				$(elea).click(function() {
					if (!$(eleb).is(':visible')) {
						$(this).addClass('clicked');
						$(eleb).slideDown();
					} else {
						$(this).removeClass('clicked');
						$(eleb).slideUp();
					}
				})
			},
			changePhone() {
				this.showPhone = !this.showPhone
				this.$emit('changePhone', this.showPhone)
			},
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						item.children.sort((a, b) => a.orderNum - b.orderNum);
					})
					this.configList = res.data
				});
			},

			changeTag(item) {
				this.selTag = item
			},
			go(url) {
				if (this.$route.fullPath != url) {
					this.$router.push(url)
					this.$router.go(0)
				}
			},
			enter(item) {
				this.selId = item.categoryCode
			},
			level(item) {
				this.selId = ''
			},
			goTwo(item) {
				let url='/'+item.url+'?type=' + item.categoryCode+'&title='+item.categoryName
				this.go(url)
			}
		}
	}
</script>